module.exports = __webpack_public_path__ + "img/self-reg.2d6d163e.svg";